export default [
  {
    //tile one (opening hours) - orange
    style: {
      top: "60px",
      left: "60px",
      width: "420px",
      height: "302px"
    },
    line: [486, 845, 266, 361]
  },
  {
    // tile two (text plus image) - light orange
    style: {
      top: "60px",
      right: "60px",
      width: "420px",
      height: "302px"
    },
    line: [598, 845, 816, 364]
  },
  {
    // tile three (text plus image) - deep orange
    style: {
      top: "420px",
      left: "330px",
      width: "420px",
      height: "302px"
    },
    line: [538, 833, 538, 723]
  },
  {
    // tile fourth (node list) - aquamarine
    style: {
      top: "778px",
      left: "60px",
      width: "260px",
      height: "644px"
    },
    line: [428, 1023, 319, 1102]
  },
  {
    // tile five (node list) - blue
    style: {
      top: "778px",
      right: "60px",
      width: "260px",
      height: "644px"
    },
    line: [655, 1021, 759, 1102]
  },
  {
    // tile six (text plus image) - yellow
    style: {
      top: "1478px",
      left: "190px",
      width: "260px",
      height: "302px"
    },
    line: [487, 1076, 318, 1477]
  },
  {
    // tile seven (texxt plus image) - purple
    style: {
      top: "1478px",
      right: "190px",
      width: "260px",
      height: "302px"
    },
    line: [596, 1075, 759, 1477]
  }
];
